module.exports = "/_next/static/images/reference-kijonkova-658ecf0f3c6fd45264df81292754c991.jpg";